import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import trovityLogo from 'src/assets/Buy_Policy_Images/trovityLogo.svg'
import logo from 'src/assets/Buy_Policy_Images/logo.svg'

const WhyConsiderTrovity = ({ insuranceName }) => {
  const classes = useStyles()
  return (
    <div className={classes.trovityContainer}>
      <div className={classes.trovityLogoContainer}>
        <div className={classes.logoContainerItem}>
          <div>
            <img
              src={trovityLogo}
              alt=''
              className={classes.trovityLogoImage}
            />
          </div>
          <span className={classes.logoContent}>
            Trovity InsureTech offers a wide range of handpicked {insuranceName}{' '}
            insurance policies from leading insurers.
          </span>
          <span className={classes.logoContentDescription}>
            We provide personalized service, expert advice, and the convenience
            of comparing multiple options to find the best coverage at
            competitive rates. With Trovity, you can have peace of mind knowing
            that your health is in trusted hands.
          </span>
        </div>
        <div className={classes.logoItemImage}>
          <img src={logo} alt='' className={classes.logo} />
        </div>
      </div>
    </div>
  )
}

export default WhyConsiderTrovity

const useStyles = makeStyles({
  trovityContainer: {
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 20,
    paddingTop: 6,
    paddingLeft: 90,
    paddingRight: 90,
    paddingBottom: 30,
    fontFamily: 'Roboto',
  },
  trovityLogoContainer: {
    marginTop: '40px',
    display: 'flex',
    '@media (max-width:750px)': {
      flexDirection: 'Column',
    },
  },
  logoContainerItem: {
    padding: '40px',
    flex: '2',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
  },
  trovityLogoImage: {
    width: '80%',
    marginBottom: '20px',
  },
  logoItemImage: {
    flex: '1',
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
  },
  logo: {
    width: '250px',
  },
  logoContent: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    display: 'flex',
    marginBottom: '20px',
  },
  logoContentDescription: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    opacity: '0.6',
  },
})
